// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    hideLoadingOverlay,
    xngLoadingOverlayUtilitiesStyles,
} from "@ces/App/Components/Common/XngLoadingOverlayUtilities";
import { mobileTippyStyle } from "@ces/App/Components/Tippy/Style";
import { xBaseTheme } from "@ces/XDL/types";
import { xScreen } from "@ces/XDL/Utilities";
import { LoadingSpinnerStyle } from "@insite/mobius/LoadingSpinner";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

export default {
    css: css`
        ${xngLoadingOverlayUtilitiesStyles}
        ${hideLoadingOverlay}
        [data-tippy-root] {
            z-index: ${getProp("theme.zIndex.tippy")} !important;
        }
        ${mobileTippyStyle}

        // This style to fix an issue with Google Places autocomplete
        .pac-container {
            z-index: 10000 !important;
        }
        // 94 + 40 margin (OOTB) = 134, the height of the header
        div[class^="PageLayoutWrapper"] > div:first-child ${LoadingSpinnerStyle} {
            height: 94px;

            ${xScreen("lte", "md")} {
                height: 117px;
            }
        }
    `,
} as xBaseTheme["globalStyle"];
